export const PERMISSIONS = {
  // Core permissions
  CHAT_ONLY: "CHAT_ONLY",
  FULL_CONTROL: "FULL_CONTROL",
  SUPER_ADMIN: "SUPER_ADMIN",
  ACCESS_MODEL_MANAGEMENT: "ACCESS_MODEL_MANAGEMENT",

  // Agent
  CREATE_AGENT: "CREATE_AGENT",

  // User
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",

  // Role
  // ADD_ROLE: "ADD_ROLE",
  // UPDATE_ROLE: "UPDATE_ROLE",
  // DELETE_ROLE: "DELETE_ROLE",
  //TODO: temporary for backward compatibility
  ADD_ROLE: "ADD_GROUP",
  UPDATE_ROLE: "UPDATE_GROUP",
  DELETE_ROLE: "DELETE_GROUP",

  // Group
  ADD_GROUP: "ADD_GROUP",
  UPDATE_GROUP: "UPDATE_GROUP",
  DELETE_GROUP: "DELETE_GROUP",

  // Document
  UPLOAD_DOCUMENT: "UPLOAD_DOCUMENT",
  UPDATE_DOCUMENT: "UPDATE_DOCUMENT",
  DELETE_DOCUMENT: "DELETE_DOCUMENT",

  // Integration
  CREATE_INTEGRATION: "create_integration",
  UPDATE_INTEGRATION: "update_integration",
  DELETE_INTEGRATION: "delete_integration",

  // API Keys
  MANAGE_API_KEYS: "MANAGE_API_KEYS",

  // Feedback
  VIEW_FEEDBACK: "VIEW_FEEDBACK",
  UPDATE_FEEDBACK: "UPDATE_FEEDBACK",

  // Technical Notes
  VIEW_TECHNICAL_NOTE: "VIEW_TECHNICAL_NOTE",

  // Suggestions
  VIEW_SUGGESTIONS: "VIEW_SUGGESTIONS",
  CREATE_SUGGESTIONS: "CREATE_SUGGESTIONS",
  UPDATE_SUGGESTIONS: "UPDATE_SUGGESTIONS",
  DELETE_SUGGESTIONS: "DELETE_SUGGESTIONS",
};
